import { animated } from 'react-spring';

import { styled } from 'theme';

export const SpinnerIconSvg = styled(animated.svg)(({ theme }) => ({
  width: '100%',
  height: '100%',
  color: theme.color?.loader.color,
}));
